var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#AD36F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19054_68874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19054_68874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.35 33.2C9.85 33.2 8.58333 32.6799 7.55 31.6396C6.51667 30.5993 6 29.3361 6 27.85C6 26.3639 6.52013 25.1007 7.5604 24.0604C8.6007 23.0201 9.8639 22.5 11.35 22.5V16.35C11.35 15.55 11.65 14.85 12.25 14.25C12.85 13.65 13.55 13.35 14.35 13.35H22.65C22.65 11.85 23.1701 10.5833 24.2104 9.55C25.2507 8.51667 26.5139 8 28 8C29.4861 8 30.7493 8.52013 31.7896 9.5604C32.8299 10.6007 33.35 11.8639 33.35 13.35H41.65C42.45 13.35 43.15 13.65 43.75 14.25C44.35 14.85 44.65 15.55 44.65 16.35V22.5C46.15 22.5 47.4167 23.0201 48.45 24.0604C49.4833 25.1007 50 26.3639 50 27.85C50 29.3361 49.4799 30.5993 48.4396 31.6396C47.3993 32.6799 46.1361 33.2 44.65 33.2V43C44.65 43.8 44.35 44.5 43.75 45.1C43.15 45.7 42.45 46 41.65 46H14.35C13.55 46 12.85 45.7 12.25 45.1C11.65 44.5 11.35 43.8 11.35 43V33.2ZM21.1617 28.2C21.7206 28.2 22.1917 28.0044 22.575 27.6133C22.9583 27.2221 23.15 26.7471 23.15 26.1883C23.15 25.6294 22.9544 25.1583 22.5633 24.775C22.1721 24.3917 21.6971 24.2 21.1383 24.2C20.5794 24.2 20.1083 24.3956 19.725 24.7867C19.3417 25.1779 19.15 25.653 19.15 26.2118C19.15 26.7706 19.3456 27.2417 19.7367 27.625C20.1279 28.0083 20.603 28.2 21.1617 28.2ZM34.8617 28.2C35.4206 28.2 35.8917 28.0044 36.275 27.6133C36.6583 27.2221 36.85 26.7471 36.85 26.1883C36.85 25.6294 36.6544 25.1583 36.2633 24.775C35.8721 24.3917 35.3971 24.2 34.8383 24.2C34.2794 24.2 33.8083 24.3956 33.425 24.7867C33.0417 25.1779 32.85 25.653 32.85 26.2118C32.85 26.7706 33.0456 27.2417 33.4368 27.625C33.8279 28.0083 34.3029 28.2 34.8617 28.2ZM19.6 37.75H36.4V34.75H19.6V37.75ZM14.35 43H41.65V16.35H14.35V43Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/robot-icon.ba5306881a76259c4c4f70492da5abb0.svg";
export { ForwardRef as ReactComponent };